import type { ReactNode } from 'react';

import { Icon } from 'components/Icon/Icon';
import type { IconName } from 'components/Icon/IconName';
import { LegacyTooltip } from 'components/LegacyTooltip/LegacyTooltip';

import {
  DetailsListItemAdditionalText,
  DetailsListItemBody,
  DetailsListItemFirstLine,
  DetailsListItemHolder,
  DetailsListItemTitle,
  DetailsListItemValue,
} from './DetailsListItem.styled';

type Props = {
  title?: string;
  iconName: IconName;
  value: ReactNode;
  additionalText?: ReactNode;
  tooltipText?: ReactNode;
  qaId?: string;
};

export function DetailsListItem({
  title,
  iconName,
  value,
  additionalText,
  tooltipText,
  qaId,
}: Props) {
  return (
    <DetailsListItemHolder data-qa-id={qaId}>
      <Icon name={iconName} size={24} colorName="lightContentGrey" />

      <DetailsListItemBody>
        <DetailsListItemFirstLine>
          {title && <DetailsListItemTitle>{title}:</DetailsListItemTitle>}
          <DetailsListItemValue>{value}</DetailsListItemValue>

          {tooltipText && (
            <div style={{ marginLeft: 8 }}>
              <LegacyTooltip greyColor>{tooltipText}</LegacyTooltip>
            </div>
          )}
        </DetailsListItemFirstLine>

        {additionalText && (
          <DetailsListItemAdditionalText>
            {additionalText}
          </DetailsListItemAdditionalText>
        )}
      </DetailsListItemBody>
    </DetailsListItemHolder>
  );
}
